//请求封装
import request from "./request.js"; //引入导出的ajax

//const host = "http://localhost:8001"
// const host = "https://www.taistar.cn/api";
const host = "https://" + window.location.host + "/api";
/**
 * 获取内容列表
 * @param {*} data {"content_type":"Banner","page":1,"size":2}
 * @returns data:list arr
 */
export function getContentPage(data) {
  //post
  return request({
    url: host + "/app/website/content/page",
    method: "post",
    data: { ...data },
  });
}

/**
 * 获取内容详情
 * @param {*} id
 * @returns
 */
export function getContentInfo(id) {
  //get
  return request({
    url: host + "/app/website/content/info?id=" + id,
    method: "GET",
  });
}

/**
 * 获取视频列表
 * @param {*} data {"page":1,"size":2}
 * @returns data:list arr
 */
export function getVideoPage(data) {
  //post
  return request({
    url: host + "/app/website/video/page",
    method: "post",
    data: { ...data },
  });
}

/**
 * 获取下载资料列表
 * @param {*} data {"down":"xx","page":1,"size":2}
 * @returns data:list arr
 */
export function getDownPage(data) {
  //post
  return request({
    url: host + "/app/website/down/page",
    method: "post",
    data: { ...data },
  });
}

/**
 * 获取合作
 * @param {*} data {"down":"xx","page":1,"size":2}
 * @returns data:list arr
 */
export function getCooprList(data) {
  //post
  return request({
    url: host + "/app/website/setting_cooperate/page",
    method: "post",
    data: { ...data },
  });
}

/**
 * 提交合作申请
 * @param {*} data {"down":"xx","page":1,"size":2}
 * @returns data:list arr
 */
export function sendCoopr(data) {
  //post
  return request({
    url: host + "/app/website/cooperate/add",
    method: "post",
    data: { ...data },
  });
}

// export default {getContentPage, getContentInfo}
//使用方式也有2种
// export const getData=(params)=>{ //get请求
//     request.get('data/user', {
//     params: {
//       ID: params
//     }
//   })
// }
// export const getData2 = (params) =>{ //post请求
//     request.post('data/user', {
//         ...params
//   })
// }
// //第二种方式
// export function getData3(data) { //post
//   return request({
//     url: 'data/list',
//     method: 'post',
//     data: { ...data }
//   })
// }

// export function getData4(id) { //get
//   return request({
//     url: 'data/one?id=' + id,
//     method: 'GET'
//   })
// }



// WEBPACK FOOTER //
// ./src/utils/api.js